export default "__VITE_ASSET__ae790386__"